export let InitialState = {
    flags: {}
}
